import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TabsNavigationItems} from "../../elements.types";

@Component({
  selector: 'as-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {

  @Input() navigation: TabsNavigationItems[];
  @Output() selectedItem = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  broadcastClickedEvent(item) {
    this.navigation.map((i)=>{
      i.selected = i.name == item.name;
    });

    this.selectedItem.emit(item)
  }
}
